// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.work-merge-panel-wrapper .work-merge-panel-list {
  display: flex;
  flex-direction: column;
  gap: 1.3rem;
}
.work-merge-panel-wrapper .reason {
  padding-top: 3.9rem;
  font-size: 1.6rem;
}
.work-merge-panel-wrapper .reason header {
  font-weight: 700;
}
.work-merge-panel-wrapper .reason textarea {
  margin-top: 1rem;
  width: 53%;
  height: 10rem;
}
.work-merge-panel-wrapper .footer {
  display: flex;
  justify-content: space-between;
  padding-top: 6.26rem;
  padding-bottom: 8.7rem;
}
.work-merge-panel-wrapper .footer .footer-button-group {
  display: flex;
  gap: 1.6rem;
}`, "",{"version":3,"sources":["webpack://./src/kit/scenes/RightsholderScene/WorkMerge/WorkMergeSearch/components/WorkMergePanel/index.scss"],"names":[],"mappings":"AACE;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AAAJ;AAGE;EACE,mBAAA;EACA,iBAAA;AADJ;AAGI;EACE,gBAAA;AADN;AAII;EACE,gBAAA;EACA,UAAA;EACA,aAAA;AAFN;AAME;EACE,aAAA;EACA,8BAAA;EACA,oBAAA;EACA,sBAAA;AAJJ;AAMI;EACE,aAAA;EACA,WAAA;AAJN","sourcesContent":[".work-merge-panel-wrapper {\n  .work-merge-panel-list {\n    display: flex;\n    flex-direction: column;\n    gap: 1.3rem;\n  }\n\n  .reason {\n    padding-top: 3.9rem;\n    font-size: 1.6rem;\n\n    header {\n      font-weight: 700;\n    }\n\n    textarea {\n      margin-top: 1rem;\n      width: 53%;\n      height: 10rem;\n    }\n  }\n\n  .footer {\n    display: flex;\n    justify-content: space-between;\n    padding-top: 6.26rem;\n    padding-bottom: 8.7rem;\n\n    .footer-button-group {\n      display: flex;\n      gap: 1.6rem;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
